<upload
    action="/api/upload"
    [drag]="true"
    [disabled]="true">
    <div>
        <i class="feather icon-upload h2"></i>
        <div class="mt-2">Drag your file or click here to upload </div>
    </div>
</upload>